import { readable } from "svelte/store";
import { HttpPromise } from "@shared/svelte/Modules/ApiService";

const start = set => {
  const getRetailer = async () => {
    const resp = await HttpPromise({
      method: "GET",
      url: "/api/retailer/retailer_distributors",
    });
    set(resp);
  };

  getRetailer();

  return function stop() {};
};

export default readable([], start);
